import { useEffect, useState } from "react";
import Header from "../component/header";
import Plastics from "../component/plastics";
import Paints from "../component/Paints";
import { Footer } from "../component/footer";
import Polyurethane from "../component/polyurethane";
import Fertilizer from "../component/fertilizer";
import Aluminiun from "../component/aluminium";
import Other from "../component/other";
import { ProductLists } from "../component/productList";


export default function Product() {
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    const updateSection = () => {
      setActiveSection(window.location.hash.replace("#", ""));
    };

    window.addEventListener("hashchange", updateSection);
    updateSection(); // Run initially to catch existing hash

    return () => {
      window.removeEventListener("hashchange", updateSection);
    };
  }, []);

  return (
    <div className="App">
      <Header />
      {/* {activeSection === "" && <ProductLists />}/ */}
      {activeSection === "plastics" && <Plastics />}
      {activeSection === "paints" && <Paints />}
      {activeSection === "polyurethane" && <Polyurethane />}
      {activeSection === "aluminium" && <Aluminiun />}
      {activeSection === "fertilizer" && <Fertilizer />}
      {activeSection === "other" && <Other />}
      <Footer />
    </div>
  );
}
